import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { LicenseProvider, GenerationProvider } from '../index'
import GccLayout from './GccLayout'
import GccHome from './GccHome'
import GccWizard from './GccWizard'
import GccDashboard from './GccDashboard'
import GccSettings from './GccSettings'
import GccTaskRegisterReviewPage from './GccTaskRegisterReviewPage'
import GccTnDashboardPage from './GccTnDashboardPage'

export default function GccApp() {
  return (
    <BrowserRouter>
      <LicenseProvider>
        <GenerationProvider>
          <Routes>
            <Route path="/gcc" element={<GccLayout />}>
              <Route index element={<GccHome />} />
              <Route path="wizard" element={<GccWizard />} />
              <Route path="dashboard/:projectId" element={<GccDashboard />} />
              <Route path="tn-dashboard/:projectId" element={<GccTnDashboardPage />} />
              <Route path="review/:projectId" element={<GccTaskRegisterReviewPage />} />
              <Route path="settings" element={<GccSettings />} />
            </Route>
            <Route path="*" element={<Navigate to="/gcc" replace />} />
          </Routes>
        </GenerationProvider>
      </LicenseProvider>
    </BrowserRouter>
  )
}
